import { CmsCopyDialogProps } from './types';
import { useResponseHandler } from '../../utils/response';
import useApi from '../../api';
import { useSnackbar } from 'notistack';
import { useTranslation } from '../../contexts/TranslationContext';
import { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import PageLocaleSelect from '../cms/PageLocaleSelect';

export default function CmsCopyDialog({
    page,
    title,
    sourceLocale,
    children,
    submitDescription = 'pages.cms.pages.copy.copy_btn',
    cancelDescription = 'form.general.cancel',
    onClose = () => {},
    onCopied = () => {},
}: CmsCopyDialogProps) {
    const { handleResponse } = useResponseHandler();
    const { cms } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const { translate } = useTranslation();

    const [selectedLocale, setSelectedLocale] = useState(sourceLocale);

    const handleClose = () => {
        onClose && onClose();
    };

    const copyPage = () => {
        if (page?.id) {
            let params = undefined;
            if (sourceLocale !== selectedLocale) {
                params = { newLocale: selectedLocale };
            }

            cms.copyPage(page.id, params).then(response => {
                handleResponse(response, () => {
                    enqueueSnackbar(translate('messages.copied'), {
                        variant: 'success',
                    });
                    onCopied();
                    handleClose();
                });
            });
        }
    };

    return (
        <Dialog
            fullWidth
            open={Boolean(page)}
            onClose={handleClose}
            maxWidth="xs">
            <DialogTitle variant="h5">
                {title ?? translate('pages.cms.pages.copy.title')}
            </DialogTitle>
            <DialogContent>
                <Stack spacing={1}>
                    <Typography>
                        {translate('pages.cms.pages.copy.text')}
                    </Typography>
                    <PageLocaleSelect
                        selectedLocale={selectedLocale}
                        onLocaleChange={setSelectedLocale}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    {translate(cancelDescription)}
                </Button>
                <Button onClick={copyPage} variant="contained">
                    {translate(submitDescription)}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
